<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import BarraDeAbajo from "./components/BarraDeAbajo.vue";
import BarraDeArriba from "./components/BarraDeArriba.vue";
import SessionAlert from "./components/SessionAlert.vue";
import ToastHost from "./components/ToastHost.vue";

/**
 * El cascarón: la barra de arriba con los tres lugares, el aviso de la
 * credencial cuando hace falta, y el contenido. En el teléfono los tres lugares
 * bajan a una barra de pestañas, que es donde alcanza el pulgar.
 *
 * La puerta se pinta sola: la barra pide datos que solo existen con sesión.
 */
const route = useRoute();
const conCascaron = computed(() => route.meta["sinCascaron"] !== true);
</script>

<template>
  <RouterView v-if="!conCascaron" />

  <div v-else class="flex min-h-full flex-col bg-canvas text-content">
    <BarraDeArriba />
    <SessionAlert />

    <!--
      `overflow-x-clip` es la red de abajo, no el arreglo: si algún día algo se
      vuelve a salir de ancho, se recorta ahí en vez de dejar que toda la página
      se desplace de lado en el teléfono. `clip` y no `hidden` porque `hidden`
      convierte a `main` en contenedor de desplazamiento y descompone lo `sticky`
      de adentro (la barra de guardar del formulario).
    -->
    <main class="px-safe relative min-w-0 flex-1 overflow-x-clip">
      <RouterView v-slot="{ Component }">
        <Transition name="page" mode="out-in">
          <div :key="$route.path" class="pb-tabbar mx-auto w-full max-w-5xl px-4 pt-6 sm:px-8 sm:pt-10 md:pb-16">
            <component :is="Component" />
          </div>
        </Transition>
      </RouterView>
    </main>

    <BarraDeAbajo />
    <ToastHost />
  </div>
</template>
